'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ListView;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ListView(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color,
      _ref$hidden = _ref.hidden,
      hidden = _ref$hidden === undefined ? true : _ref$hidden;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': hidden, className: 'icon-svg-list-view ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('rect', { width: '13.635', height: '1.75', x: '1.365', y: '2.875', fill: color }),
      _react2.default.createElement('rect', { width: '13.635', height: '1.75', x: '1.365', y: '7.125', fill: color }),
      _react2.default.createElement('rect', { width: '13.635', height: '1.75', x: '1.365', y: '11.375', fill: color })
    )
  );
}

ListView.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/ListView/ListView.js
// module id = 267
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16